import type { ReactNode } from "react";
import PiWidget from "../../components/pi_widget/PiWidget";
import { useSelector } from "react-redux";
import {
  SelectedTab,
  selectSelectedTab,
} from "../../app/slices/GlobalSlice";

export default function ViewportTools(props: { children?: ReactNode }) {
  const { children } = { ...props };
  const timelineSelected =
    useSelector(selectSelectedTab) === SelectedTab.Timeline;

  const widget = (
    <PiWidget>
      <>{children}</>
    </PiWidget>
  );

  return <>{timelineSelected && widget}</>;
}
